<template>
    <div class="ds-top-slot-headline-subheadline">
        <WebpImage
            v-if="imageSrc"
            :src="imageSrc"
            :alt="imageAlt"
            css-class="ds-top-slot-headline-subheadline__image"
        />
        <div>
            <h2
                v-if="displayHeadlineAsHtml"
                class="ds-top-slot-headline-subheadline__headline"
                v-html="headline"
                :id="dialogLabelId"
            ></h2>
            <h2 v-else class="ds-top-slot-headline-subheadline__headline" :id="dialogLabelId">{{ headline }}</h2>
            <p v-if="subheadline" class="ds-top-slot-headline-subheadline__subheadline" v-html="subheadline"></p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import WebpImage from "../image/webp-image.vue";

withDefaults(
    defineProps<{
        /**
         * Headline text
         */
        headline: string;
        /**
         * Subheadline text
         */
        subheadline?: string;
        /**
         * Image src
         */
        imageSrc?: string;
        /**
         * Image alt
         */
        imageAlt?: string;
        /**
         * Tells whether resolve HTML markup in headline
         */
        displayHeadlineAsHtml?: boolean;
        /**
         * Id to hook on aria-labelledby
         */
        dialogLabelId?: string;
    }>(),
    {
        dialogLabelId: "dialog-label",
    }
);
</script>
